import React, { useState } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";
import { useId } from "@react-aria/utils";

import Label from "../Label";
import { SwitchProps } from "./Switch.types";
import { StyledDot, StyledInput, StyledSwitchContainer } from "./Switch.styles";
import Box from "../../layout/boxes/Box/Box";

const Switch = ({
	onChange,
	id,
	className,
	size = "lg",
	defaultChecked,
	label,
	disabled = false,
	...props
}: SwitchProps) => {
	const block = new BemIt("Switch");

	const [animationClass, setAnimationClass] = useState("");
	const [checked, setChecked] = useState(defaultChecked || false);

	const internalId = useId();
	const labelId = useId();

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newState = !checked;

		if (typeof onChange === "function") {
			onChange(e.target.id, newState);
		}
		const className = block.mod(newState ? "bounce-left" : "bounce-right").out;
		setAnimationClass(className);
		setChecked((prevState) => !prevState);
	};

	return (
		<Box
			className={addClass(className).after(block)}
			display="flex"
			alignItems="center"
			{...props}
		>
			<StyledSwitchContainer size={size} checked={checked} disabled={disabled}>
				<StyledInput
					id={id || internalId}
					type="checkbox"
					checked={checked}
					onChange={handleChange}
					defaultChecked={defaultChecked}
					aria-labelledby={labelId}
					disabled={disabled}
				/>
				<StyledDot
					size={size}
					className={animationClass}
					checked={checked}
					disabled={disabled}
				/>
			</StyledSwitchContainer>
			<Label
				display="inline-block"
				marginLeft={size === "lg" ? "md" : "sm"}
				size={size}
				id={labelId}
			>
				{label}
			</Label>
		</Box>
	);
};

export default Switch;
